module.exports = __webpack_public_path__ + "static/media/newin.eb4fac9c.webp";